type CardPlaceholderSize = "md" | "lg";

const cardPlaceholder = (size: CardPlaceholderSize) => {
  const labels = `
  <div class="flex mt-2">
    <span class="animate-pulse rounded box-border w-20 h-6 mr-2 bg-placeholder"></span>
    <span class="animate-pulse rounded box-border w-24 h-6 bg-placeholder"></span>
  </div
  `;

  return `
  <li class="animate-fade-in">
    <div class="animate-pulse box-border w-full h-auto pb-full rounded bg-background-secondary"></div>
    <div class="box-border mt-2 mb-1 md:mt-4">
      <div class="animate-pulse rounded box-border w-1/2 h-5 mb-2 bg-placeholder"></div>
      <div class="animate-pulse rounded box-border w-4/5 h-3 mb-1 bg-placeholder hidden md:block"></div>
      <div class="animate-pulse rounded box-border w-1/2 h-3 mb-3 bg-placeholder hidden md:block"></div>
      <div class="animate-pulse rounded box-border w-3/4 md:w-1/2 h-3 md:h-4 bg-placeholder"></div>
      <div class="box-border w-full h-3 md:h-4"></div>
      <div class="animate-pulse rounded box-border w-full h-5 md:h-7 bg-placeholder"></div>
      ${size === "lg" ? labels : ""}
    </div>
  </li>
  `;
};

export const createCardPlaceholders = (
  pageSize: number,
  size: CardPlaceholderSize = "md"
) => {
  const placeholder = cardPlaceholder(size);
  return Array.from({ length: pageSize }, () => {
    const template = document.createElement("template");

    template.innerHTML = placeholder;
    return template.content.firstElementChild;
  }).filter((el): el is Element => el instanceof Element);
};
